var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-user-list-opener",on:{"click":() => _vm.$emit('click')}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icon",attrs:{"src":require('@/assets/user.svg'),"alt":"open user list"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }